import * as HttpService from "../../../../service/HttpService"

/** 系统管理  -> 角色管理服务 **/

/**
 * 获取角色列表
 */
export const getRoleList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/rolemgmt/dataList", params);
}

/**
 * 新增角色
 */
export const addRole = (role) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/rolemgmt/addRoleDo", role);
}

/**
 * 编辑角色
 */
export const editRole = (role) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/rolemgmt/editRoleDo", role);
}

/**
 * 删除角色
 */
export const deleteRole = (roleId) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/rolemgmt/deleteRole/" + roleId);
}

/**
 * 通过角色id获取角色信息
 * @param roleId 角色id
 */
export const getRoleInfoByRoleId = (roleId) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/rolemgmt/loadRole/" + roleId);
}
